/*
 * File: QuoteIdSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 26 Jan 2022 4:53:47 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterQuoteId } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

export const QuoteIdSearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterQuoteId(ev.target.value));
  }, 500);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput placeholder="Quote Id" onChange={handleInputChange} width={150} />
    </Space>
  );
};
